import { render, staticRenderFns } from "./CrmStatusSelect.vue?vue&type=template&id=7b230edb"
import script from "./CrmStatusSelect.vue?vue&type=script&lang=ts"
export * from "./CrmStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b230edb')) {
      api.createRecord('7b230edb', component.options)
    } else {
      api.reload('7b230edb', component.options)
    }
    module.hot.accept("./CrmStatusSelect.vue?vue&type=template&id=7b230edb", function () {
      api.rerender('7b230edb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmStatusSelect.vue"
export default component.exports